// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../Config.bs.js";
import * as CrmNetwork from "../../../../../library/network/CrmNetwork.bs.js";
import * as NetworkUtils from "../../../../../library/NetworkUtils.bs.js";
import * as CountryConfig from "../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as PartnerPenaltyRepoConfig from "./PartnerPenaltyRepoConfig.bs.js";
import * as CreateManualPenaltyPayload from "../api-model/CreateManualPenaltyPayload.bs.js";
import * as DeletePartnerPenaltyPayload from "../api-model/DeletePartnerPenaltyPayload.bs.js";

var fetchManualPenaltyListPath = Config.Env.getHostName(undefined) + "/driver_manual_penalty/fetch_manual_penalties_v2";

var createManualPenaltyPath = Config.Env.getHostName(undefined) + "/driver_manual_penalty/create_manual_penalty_v2";

var fetchPartnerPenaltiesPath = Config.Env.getHostName(undefined) + "/driver_manual_penalty/fetch_partner_penalties";

var deletePartnerPenaltyPath = Config.Env.getHostName(undefined) + "/driver_manual_penalty/delete_penalty_v2";

function fetchManualPenaltyList(msisdn, order_id, country) {
  var requestUrl = fetchManualPenaltyListPath + "?msisdn=" + msisdn + "&order_id=" + order_id;
  return NetworkUtils.catchPromiseError(CrmNetwork.get(requestUrl, undefined, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PartnerPenaltyRepoConfig.ManualPenaltyListResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function createManualPenalty(payload, country) {
  var encodedPayload = JSON.stringify(CreateManualPenaltyPayload.t_encode(payload));
  return NetworkUtils.catchPromiseError(CrmNetwork.postRequestV2(createManualPenaltyPath, undefined, encodedPayload, {
                    coutry: CountryConfig.countryToString(country)
                  }, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PartnerPenaltyRepoConfig.EditManualPenaltyResponseConverter.execute, result);
                            });
                }), createManualPenaltyPath);
}

function fetchPartnerPenalties(crn, msisdn, start_time, end_time, country) {
  var requestUrl = fetchPartnerPenaltiesPath + "?order_crn=" + crn + "&msisdn=" + msisdn + "&start_time=" + start_time + "&end_time=" + end_time;
  return NetworkUtils.catchPromiseError(CrmNetwork.get(requestUrl, undefined, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PartnerPenaltyRepoConfig.PartnerPenaltyResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function deletePartnerPenalty(payload, country) {
  var encodedPayload = JSON.stringify(DeletePartnerPenaltyPayload.t_encode(payload));
  return NetworkUtils.catchPromiseError(CrmNetwork.postRequestV2(deletePartnerPenaltyPath, undefined, encodedPayload, {
                    coutry: CountryConfig.countryToString(country)
                  }, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PartnerPenaltyRepoConfig.EditManualPenaltyResponseConverter.execute, result);
                            });
                }), deletePartnerPenaltyPath);
}

var PartnerPenaltyRepo = {
  fetchManualPenaltyList: fetchManualPenaltyList,
  createManualPenalty: createManualPenalty,
  fetchPartnerPenalties: fetchPartnerPenalties,
  deletePartnerPenalty: deletePartnerPenalty
};

export {
  PartnerPenaltyRepo ,
  
}
/* fetchManualPenaltyListPath Not a pure module */
